export default __webpack_public_path__ + "static/media/user-logo.40aa7227.svg";